var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":"","lg4":"","align-self-center":""}},[_c('apexchart',{staticStyle:{"font-size":"6px"},attrs:{"type":"donut","height":"400","width":"100%","options":_vm.chartOptions,"series":_vm.series}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }